<template>
  <div class="panel">
    <div>
      <div>
        <el-row :inline="true">
          <el-col  :span="18" :inline="true">
            <el-input size="small" placeholder="机构编码或名称" v-model="search">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </el-col>
          <el-col  :span="4" :inline="true" style="float:right">
            <el-button type="primary" size="small" icon="el-icon-check" @click="saveUser">确定</el-button>
          </el-col>
        </el-row>
      </div>
      <div style="margin-top: 8px; overflow: auto; height: 500px">
        <el-tree
          ref="tree"
          node-key="id"
          :data="data"
          show-checkbox 
          check-strictly=true 
          :filter-node-method="filterNode"
          :props="defaultProps"
          :default-checked-keys="defaultChecked"
          :default-expanded-keys="expandedId"
          :expand-on-click-node="false"
        ></el-tree>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "@/kits/utils";
import debounce from "lodash.debounce";

let _kits, originalArrayData;

export default {
  watch: {
    search(val) {
      this.$refs.tree.filter(val);
    }
  },
  data() {
    var r = {
      view: {
        height: "auto"
      },
      clickCount: 0,
      defaultProps: {
        children: "children",
        label: "label"
      },
      expandedId: [],
      defaultChecked: [],
      data: [],
      search: ""
    };
    return r;
  },
  methods: {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1 || data.id.indexOf(value) !== -1;
    },
    saveUser(){
      var checkedNodes = this.$refs.tree.getCheckedNodes();
      console.log(checkedNodes);
      if(checkedNodes.length>0){
        this.$emit("chose", checkedNodes);
      }else{
        this.$message.error("请至少选中一个开票员");
      }
    }
  },
  created() {
    _kits = this.$kits()
    this.$api.call({
      name: "LOGINCZRYTREE",
      view: this,
      success: result => {
        this.data = _kits.arr2TreeData(result, a => {});
        this.expandedId.push(this.data[0].id);
      }
    });
  }
};
</script>
<style scoped>
.panel {
  background: #f0f1f1;
  padding: 20px;
}
</style>
